<template>
  <div class="subPage-template">
    <div class="subPage-title">
      <div :class="['title-item', selectItem === '1' ? 'active' : '']" @click="changeItem('1')">推荐</div>
      <div :class="['title-item', selectItem === '2' ? 'active' : '']" @click="changeItem('2')">我的</div>
    </div>
    <div class="subPage-content">
      <div
        ref="scrollbar"
        v-if="contentStyles.length > 0"
        :class="['content-styles', request_prefix === 'stage' ? 'pc' : 'app']"
      >
        <div
          :class="['content-style-item', templateId === style.encId ? 'active' : '']"
          v-for="(style, index) in contentStyles"
          :key="index"
        >
          <div class="content-img-box" @click="changeContentStyle(style)">
            <img :src="style.cover ? style.cover : defaultImg" alt="" />
          </div>
          <div class="content-text overflowHid1">{{ style.title }}</div>
          <i class="icon-checked"></i>
        </div>
      </div>
      <div v-else class="content-styles--empty">
        <div class="content-container">
          <div class="content-image"></div>
          <div class="content-title">暂无我的模板</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "subPage-setting",
  data() {
    return {
      defaultImg: require("../../../assets/images/default_image_home.png"),
      typeUpdateTimer: null,
      selectItem: "1",
      curPage: 1,
      pageNum: 20,
      totalPage: 0, //总页码
      typeId: undefined,
      contentStyles: [],
      collectTypeId: 0, //收藏模版的分类id
      collectId: 0,
      templateId: null,
      scrollTimer: null,
      editing: false,
      pcSubPage: {},
      appSubPage: {}
    }
  },
  computed: {
    otherTypes() {
      const menuType = this.request_prefix === "stage" ? "menu" : "appMenu"
      return this.$store.state[menuType].menu.otherTypes
    },
    isListPage() {
      return this.$store.state.states.getDataPageIds.pv === "1"
    },
    appId() {
      return this.$store.state.states.getDataPageIds.appId
    },
    urlParams() {
      return this.$store.state.states.getDataPageIds
    },
    pluginName() {
      return this.$store.state[this.request_prefix].page?.pluginName || []
    }
  },
  mounted() {
    // 这里做一个轮询，因为最开始进来，otherTypes获取不到，直到获取到了再查询
    this.typeUpdateTimer = setInterval(() => {
      if (this.otherTypes && this.pluginName) {
        clearInterval(this.typeUpdateTimer)
        this.getPageLayoutTypes()
      }
    }, 20)
    const pcSubPage = JSON.parse(localStorage.getItem("subPageSetting-" + this.appId + "-stage"))
    const appSubPage = JSON.parse(localStorage.getItem("subPageSetting-" + this.appId + "-appStage"))
    this.pcSubPage = pcSubPage
    this.appSubPage = appSubPage
    const pageKey = this.isListPage ? "listPageTemplateId" : "detailPageTemplateId"
    this.templateId = this.request_prefix === "stage" ? pcSubPage[pageKey] : appSubPage[pageKey]
    this.scrollTimer = setTimeout(() => {
      this.$refs.scrollbar?.addEventListener("scroll", this.listenerScroll)
    }, 2000)
  },
  beforeDestroy() {
    clearTimeout(this.scrollTimer)
    this.$refs.scrollbar?.removeEventListener("scroll", this.listenerScroll)
  },
  methods: {
    changeItem(type) {
      if (this.selectItem === type) {
        return
      }
      this.selectItem = type
      this.curPage = 1
      this.contentStyles = []
      if (this.pluginName.indexOf("groupSearchListPagePlugin") > -1 && type === "2") {
        this.totalPage = 0
      } else {
        this.getStyles()
      }
    },
    getPageLayoutTypes() {
      const menuType = this.request_prefix === "stage" ? "menu" : "appMenu"
      const listPageTypeName = this.request_prefix === "stage" ? "列表页模板" : "移动端列表页模板"
      const detailPageTypeName = this.request_prefix === "stage" ? "详情页模板" : "移动端详情页模板"

      let listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === listPageTypeName)[0]
        .encId
      const detailPageEncId = this.$store.state[menuType].menu.otherTypes.filter(
        item => item.name === detailPageTypeName
      )[0].encId

      if (location.href.indexOf("searchKey") > -1) {
        const firstLevelName = this.request_prefix === "stage" ? "搜索列表页" : "移动端搜索列表页"
        listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]
          .encId
      }
      const isNav = this.request_prefix === "stage" ? this.pcSubPage.nav : this.appSubPage.nav
      if (isNav) {
        const firstLevelName = this.request_prefix === "stage" ? "导航列表页" : "移动端导航列表页"
        listPageEncId = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]
          .encId
      }
      if (this.pluginName.indexOf("groupSearchListPagePlugin") > -1) {
        const firstLevelName = this.request_prefix === "stage" ? "搜索列表页" : "移动端搜索列表页"
        const searchList = this.$store.state[menuType].menu.otherTypes.filter(item => item.name === firstLevelName)[0]
          ?.subs
        const subLevelName = this.request_prefix === "stage" ? "聚合检索列表页" : "移动端聚合检索列表页"
        listPageEncId = searchList?.filter(item => item.name === subLevelName)[0].encId
      }

      this.typeId = this.isListPage ? listPageEncId : detailPageEncId
      this.getTypeList()
    },
    getStyles(flag) {
      this.$API
        .queryComponentList({
          typeId: this.selectItem === "1" ? this.typeId : this.collectTypeId,
          p: this.curPage,
          p2: this.pageNum,
          lsc: this.selectItem === "1"
        })
        .then(res => {
          if(flag === 'add'){
            let contentStyles = (res.data?.data?.PageInfo?.list || []).filter(item =>
              this.selectItem === "1" ? item.typeId !== this.collectId : item.typeId === this.collectId
            )
            this.contentStyles = this.contentStyles.concat(contentStyles)
          }else{
            this.contentStyles = (res.data?.data?.PageInfo?.list || []).filter(item =>
              this.selectItem === "1" ? item.typeId !== this.collectId : item.typeId === this.collectId
            )
            this.totalPage = res.data?.data?.PageInfo?.pages
          }
          if(this.contentStyles.length < this.pageNum && this.curPage < this.totalPage){
            this.curPage++
            this.getStyles("add")
          }
        })
    },
    async getTypeList() {
      this.$API.queryComponentTypeTree({ pid: this.typeId, countSub: true }).then(res => {
        const collectItem = res.data.data.list.filter(item => item.name.indexOf("我的") > -1)
        this.collectTypeId = collectItem && collectItem[0]?.encId
        this.collectId = collectItem && collectItem[0]?.id
        this.getStyles()
      })
    },
    async changeContentStyle(style) {
      const subPage = JSON.parse(localStorage.getItem("subPageSetting-" + this.appId + "-" + this.request_prefix))
      const hideTip = this.isListPage ? subPage.listPageIsUseSystemTemplate : subPage.detailPageIsUseSystemTemplate
      if (this.templateId !== style.encId) {
        if (hideTip) {
          this.changeTeplate(subPage, style)
        } else {
          this.$confirm("切换模板后，模板样式将覆盖现有样式。操作无法撤回，确认切换吗？", "", {
            confirmButtonText: "确认",
            cancelButtonText: "取消",
            showClose: false,
            dangerouslyUseHTMLString: "<p>确认模板吗？</p>",
            iconClass: "bigScreen_confirm_icon el-icon-warning",
            cancelButtonClass: "bigScreen_confirm_cancel_button",
            confirmButtonClass: "bigScreen_confirm_button",
            customClass: "bigScreen_confirm custom_warning_dialog"
          })
            .then(() => {
              this.changeTeplate(subPage, style)
            })
            .catch(() => {})
        }
      }
    },
    changeTeplate(subPage, style) {
      sessionStorage.removeItem("hasBreadCrumbs")
      sessionStorage.removeItem("hasNavMenuVertical")
      sessionStorage.removeItem("hasSearchComponent")
      sessionStorage.removeItem("hasPrevNext")
      this.templateId = style.encId
      if (this.isListPage) {
        subPage.listPageTemplateId = style.encId
        subPage.listPageIsUseSystemTemplate = true
      } else {
        subPage.detailPageTemplateId = style.encId
        subPage.detailPageIsUseSystemTemplate = true
      }
      localStorage.setItem("subPageSetting-" + this.appId + "-" + this.request_prefix, JSON.stringify(subPage))
      const subPageEditInfo = this.$store.state.states.subPageEditInfo
      subPageEditInfo.edit = true
      subPageEditInfo.type = "template"
      subPageEditInfo.value = this.templateId
    },
    listenerScroll(e) {
      let height = e.target.scrollHeight - e.target.clientHeight
      if (height - e.target.scrollTop < 4 && height != 0 && this.curPage < this.totalPage) {
        this.curPage++
        this.$API
          .queryComponentList({
            typeId: this.selectItem === "1" ? this.typeId : this.collectTypeId,
            p: this.curPage,
            p2: this.pageNum,
            lsc: true
          })
          .then(res => {
            if (res.data.code === 1) {
              const data = (res.data.data?.PageInfo?.list || []).filter(item => item.typeId !== this.collectId)
              this.contentStyles.push(...data)
            }
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.subPage-template {
  .subPage-title {
    height: 36px;
    padding-left: 6px;
    border-bottom: 1px solid rgba(233, 233, 233, 1);
    display: flex;
    .title-item {
      width: 48px;
      height: 36px;
      padding: 8px 10px;
      color: rgba(0, 0, 0, 0.4);
      font-size: 14px;
      font-weight: 400;
      line-height: 20px;
      text-align: center;
      cursor: pointer;
      &:hover {
        color: rgba(0, 0, 0, 0.8);
      }
      &.active {
        color: rgba(0, 0, 0, 0.8);
        font-weight: 600;
      }
    }
  }
  .subPage-content {
    .content-styles {
      display: flex;
      padding: 16px;
      flex-wrap: wrap;
      column-gap: 8px;
      row-gap: 12px;
      max-height: calc(100vh - 190px);
      overflow: auto;
      &::-webkit-scrollbar {
        width: 0;
      }
      &.pc .content-style-item {
        width: 100%;
      }
      &.app .content-style-item {
        width: 110px;
      }
      .content-style-item {
        cursor: pointer;
        height: 160px;
        border-radius: 4px;
        padding: 2px;
        position: relative;
        &.active {
          box-shadow: 0 0 0 2px var(--themeColor) inset;
          .icon-checked {
            display: block;
          }
        }
        &:not(.active):hover {
          box-shadow: 0 0 0 2px var(--themeColorDisabled) inset;
        }
        &:not(.active) {
          box-shadow: 0 0 0 1px var(--elCollapseItemBorderColor) inset;
        }
        .icon-checked {
          position: absolute;
          right: 1px;
          top: 1px;
          width: 24px;
          height: 24px;
          background-image: url(../../../assets/images/icon-checked.png);
          background-size: 100% 100%;
          display: none;
        }
        .content-img-box {
          height: 114px;
          overflow: hidden;
          img {
            width: 100%;
            // height: 100%;
          }
        }
        .content-text {
          height: 42px;
          padding: 12px;
          font-size: 13px;
          font-weight: 400;
          line-height: 20px;
          color: rgba(0, 0, 0, 0.8);
          background: rgba(255, 255, 255, 0.8);
        }
      }
    }
    .content-styles--empty {
      padding: 60px 16px;
      .content-container {
        width: 228px;
        height: 138px;
        padding: 0px 10px;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: space-between;
        .content-image {
          width: 140px;
          height: 100px;
          background: url(../../../assets/images/empty-template.png) no-repeat;
        }
        .content-title {
          font-size: 13px;
          font-weight: 400;
          line-height: 22px;
        }
      }
    }
  }
}
</style>
